import { CustomFieldWithValue } from 'App/resources/Model/CustomField';
import RequestBuilder from 'Resources/RequestBuilder';
import { openDrawer } from 'Services/Drawer';

export default function planTodos(
	rb: RequestBuilder,
	entity: string,
	numSelected: number,
	selected: number[],
	extraParams?: {
		isUpdateTodos?: boolean;
		onSave?: (properties: any, customFields?: CustomFieldWithValue[]) => Promise<any> | void;
		[key: string]: any;
	}
) {
	const opts = {
		filters: rb,
		entity,
		numSelected,
		extraParams,
		selected
	};

	return openDrawer('CreateTodosMulti', opts);
}
